import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import React, { useContext } from 'react';
import { AlertVariantContext } from './index';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'alert'
});
export var AlertClose = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "children"]);

  var variant = useContext(AlertVariantContext);
  return _jsx(As, {
    sx: {
      variant: "".concat(variantPath(variant), ".close")
    },
    children: _jsx("button", _objectSpread(_objectSpread({
      ref: ref,
      sx: {
        float: 'right',
        display: 'block',
        top: '0px',
        right: '0px',
        width: '32px',
        height: '32px',
        p: 0,
        border: 'none',
        transform: 'translate(8px, -8px)',
        cursor: 'pointer',
        color: 'unset',
        backgroundColor: 'transparent',
        appearance: 'none'
      }
    }, props), {}, {
      children: _jsx("svg", {
        sx: {
          position: 'absolute',
          display: 'block',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        },
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: _jsx("path", {
          d: "M12.6666 4.27334L11.7266 3.33334L7.99992 7.06L4.27325 3.33334L3.33325 4.27334L7.05992 8L3.33325 11.7267L4.27325 12.6667L7.99992 8.94L11.7266 12.6667L12.6666 11.7267L8.93992 8L12.6666 4.27334Z"
        })
      })
    }))
  });
});
AlertClose.displayName = 'AlertClose';